import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@material-ui/core';
import {
  allAmenitiesSelector,
  allRestaurantSelector,
  allRoomTypesSelector,
  allSpaInfoSelector,
} from '../../../layouts/property/propertySlice';
import { offerSelector } from '../../../layouts/cms/cmsSlice';

const ModuleIdSelector = (props) => {
  const {
    hotelModule,
    hotelModuleId,
    onChangeHotelModuleId,
    disabled,
    hideNullOption,
    nullOptionLabel,
    error,
    required,
    requiredError,
  } = props;
  const allRestaurantoptions = useSelector(allRestaurantSelector);
  const allSpaOptions = useSelector(allSpaInfoSelector);
  const allRoomsOptions = useSelector(allRoomTypesSelector);
  const allAmenitiesOptions = useSelector(allAmenitiesSelector);
  const allOffers = useSelector(offerSelector);
  // might need this later so keeping it here.
  // const allExperienceOptions = useSelector();

  const [moduleIdOptions, setModuleIdOptions] = useState(allRestaurantoptions);
  const [label, setLabel] = useState('');

  useEffect(() => {
    switch (hotelModule) {
      case 'ROOMS':
        setLabel('Select Room Type');
        setModuleIdOptions(allRoomsOptions.filter((item) => item.isActive));
        break;
      case 'RESTAURANT':
        setLabel('Select Restaurant');
        setModuleIdOptions(allRestaurantoptions.filter((item) => item.isActive));
        break;
      case 'WELLNESS':
        setLabel('Select Spa');
        setModuleIdOptions(allSpaOptions.filter((item) => item.isActive));
        break;
      case 'EXPERIENCES':
        setLabel('Select Experience');
        setModuleIdOptions([]);
        break;
      case 'AMENITY':
        setLabel('Select Hotel Compendium');
        setModuleIdOptions(allAmenitiesOptions.filter((item) => item.isActive));
        break;
      case 'OFFERS':
        setLabel('Select Offer');
        setModuleIdOptions(
          allOffers?.filter((item) => ['Live', 'Scheduled']?.includes(item?.status)),
        );
        break;
      default:
        setLabel('');
        setModuleIdOptions([]);
        break;
    }
  }, [hotelModule]);

  const onChange = (e) => {
    const getName = moduleIdOptions.find((currModule) => currModule.id === e.target.value);
    onChangeHotelModuleId(e, getName?.name);
  };

  return (
    <FormControl className='w-100' error={error} required={required}>
      <InputLabel id='hotel-module-'>{label || 'Select Sub Module'}</InputLabel>
      <Select
        disabled={disabled}
        labelId='hotel_module_label'
        id='hotel_module_select'
        autoWidth={false}
        value={hotelModuleId}
        onChange={(e) => {
          onChange(e);
        }}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
        }}
      >
        {!hideNullOption && (
          <MenuItem value=''>
            <em>{nullOptionLabel || 'None'}</em>
          </MenuItem>
        )}

        {moduleIdOptions.map((item, key) => {
          return (
            <MenuItem key={key} value={item?.id}>
              {item?.name}
            </MenuItem>
          );
        })}
      </Select>
      <FormHelperText>{error ? requiredError || 'Hotel Module required' : ''}</FormHelperText>
    </FormControl>
  );
};

export default ModuleIdSelector;
